import server from 'common/utils/server';
import { getSearchFilter } from 'common/utils/locationUtils';

export function scorecardSectionStatsState(
  state = {
    sectionsByScorecardId: {},
    employeesByScorecardId: {},
  },
  action
) {
  switch (action.type) {
    case 'scorecaredSectionStats/RECEIVED': {
      const { scorecardId, sections, employees, totalMembersPages, totalMembersCount } = action;
      const sectionsByScorecardId = { ...state.sectionsByScorecardId };
      const employeesByScorecardId = { ...state.employeesByScorecardId };
      sectionsByScorecardId[scorecardId] = sections;
      employeesByScorecardId[scorecardId] = employees;
      return {
        ...state,
        sectionsByScorecardId,
        employeesByScorecardId,
        totalMembersPages: totalMembersPages,
        totalMembersCount: totalMembersCount,
      };
    }
    default: {
      return state;
    }
  }
}

export const loadTeamMemberScorecardStats =
  ({ history, scorecardId, customProperties }) =>
  async dispatch => {
    const {
      startDate,
      endDate,
      teamIds,
      groupIds,
      reportingGroupIds,
      employeeIds,
      reviewerIds,
      autofailed,
      languages,
      channelEnumIds,
      propertyIds,
      page,
    } = getSearchFilter(history);
    const result = await server.get('/api/v1/qa_reporting/team_members_scorecard_sections', {
      completed_from: startDate,
      completed_to: endDate,
      by_reviewer_id: reviewerIds,
      by_employee_id: employeeIds,
      for_teams: teamIds,
      for_groups: groupIds,
      for_reporting_groups: reportingGroupIds,
      qa_form_id: scorecardId,
      by_language: languages,
      by_channel_enum_id: channelEnumIds,
      by_property_id: propertyIds,
      autofailed,
      ...(page && { members_page: page }),
      custom_properties: customProperties,
    });
    const sections = [];
    result.sections.forEach(section => {
      sections.push({
        sectionId: section.id,
        sectionName: section.name,
      });
    });
    const employees = [];
    result.team_members.forEach(employee => {
      const sectionScoresBySectionId = {};
      Object.entries(employee.sections).forEach(([sectionId, sectionScore]) => {
        sectionScoresBySectionId[sectionId] = {
          score: sectionScore.score,
          previousScore: sectionScore.previous_score,
        };
      });
      employees.push({
        employeeId: employee.id,
        employeeName: employee.name,
        employeeImage: employee.image,
        scoredReviewCount: employee.scored,
        unscoredReviewCount: employee.unscored,
        averageScore: {
          score: employee.average_score.score,
          previousScore: employee.average_score.previous_score,
        },
        sectionScoresBySectionId,
      });
    });

    dispatch({
      type: 'scorecaredSectionStats/RECEIVED',
      scorecardId,
      sections,
      employees,
      totalMembersPages: result.total_pages,
      totalMembersCount: result.total_members,
    });
  };
